module.exports = __webpack_public_path__ + "img/CROWN BN.f2402fa.svg";